var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1190_34229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7419 10.348C12.7102 9.02669 13.1439 7.3885 12.9562 5.76116C12.7685 4.13381 11.9733 2.63735 10.7297 1.57114C9.48604 0.504928 7.88567 -0.0523897 6.24876 0.0106835C4.61184 0.0737566 3.05911 0.752569 1.90119 1.91131C0.743273 3.07006 0.0655718 4.62328 0.00366997 6.26024C-0.0582319 7.8972 0.500231 9.49717 1.56733 10.7401C2.63443 11.9829 4.13147 12.7771 5.75894 12.9636C7.38641 13.1501 9.0243 12.7152 10.3449 11.746H10.3439C10.3739 11.786 10.4059 11.824 10.4419 11.861L14.2919 15.711C14.4794 15.8986 14.7338 16.0041 14.9991 16.0042C15.2643 16.0043 15.5188 15.899 15.7064 15.7115C15.8941 15.524 15.9995 15.2696 15.9996 15.0044C15.9997 14.7391 15.8944 14.4846 15.7069 14.297L11.8569 10.447C11.8212 10.4108 11.7827 10.3774 11.7419 10.347V10.348ZM11.9999 6.50401C11.9999 7.22628 11.8577 7.94147 11.5813 8.60877C11.3049 9.27606 10.8997 9.88237 10.389 10.3931C9.87829 10.9038 9.27197 11.3089 8.60468 11.5853C7.93739 11.8617 7.22219 12.004 6.49992 12.004C5.77765 12.004 5.06245 11.8617 4.39516 11.5853C3.72787 11.3089 3.12156 10.9038 2.61083 10.3931C2.10011 9.88237 1.69498 9.27606 1.41858 8.60877C1.14218 7.94147 0.999921 7.22628 0.999921 6.50401C0.999921 5.04532 1.57938 3.64637 2.61083 2.61492C3.64228 1.58347 5.04123 1.00401 6.49992 1.00401C7.95861 1.00401 9.35756 1.58347 10.389 2.61492C11.4205 3.64637 11.9999 5.04532 11.9999 6.50401Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1190_34229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.00402832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.1f8cd45f75833cac985a2cb20e982d5d.svg";
export { ForwardRef as ReactComponent };